var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._t("default",null,null,{ isIdle: _vm.isIdle, isPending: _vm.isPending, isResolved: _vm.isResolved, isRejected: _vm.isRejected, submit: _vm.handleSubmit })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }